import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { applyThemeColors } from './constants';
import './index.css';
import './index.module.css';
import './styles/global.css';
import App from './App';

applyThemeColors();

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// build/index.html ships prerendered markup for SEO — hydrate it instead of
// throwing away and re-rendering. Fresh visits (404.html shell) mount from scratch.
if (container.hasChildNodes()) {
  hydrateRoot(container, app, {
    onRecoverableError(error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
    },
  });
} else {
  createRoot(container).render(app);
}
